
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Betere error logging
console.log('RoosterApp wordt gestart...');

// Zorg ervoor dat we aan het root-element koppelen
const rootElement = document.getElementById("root");
if (rootElement) {
  try {
    console.log('Root element gevonden, app renderen...');
    createRoot(rootElement).render(<App />);
    console.log('App succesvol gerenderd');
  } catch (error) {
    console.error('Fatale fout bij het renderen van de app:', error);
    
    // Toon fallback UI in geval van fatale render-fout
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: system-ui, sans-serif;">
        <h1 style="color: #e11d48;">Er is een fout opgetreden</h1>
        <p>De applicatie kon niet worden geladen. Probeer de pagina te vernieuwen.</p>
        <pre style="background: #f1f5f9; padding: 12px; border-radius: 6px; text-align: left; overflow: auto; margin-top: 20px; font-size: 12px;">${error instanceof Error ? error.message : String(error)}</pre>
        <button onclick="window.location.reload()" style="background: #0284c7; color: white; border: none; padding: 8px 16px; border-radius: 6px; margin-top: 20px; cursor: pointer;">Pagina vernieuwen</button>
      </div>
    `;
  }
} else {
  console.error("Root element niet gevonden! Controleer of er een div met id 'root' in index.html staat");
}

// Voeg een globale error handler toe
window.addEventListener('error', (event) => {
  console.error('Onbehandelde fout:', event.error);
  // Voorkom dat de fout de hele applicatie laat crashen
  event.preventDefault();
});

// Log wanneer de app succesvol is geladen
console.log('RoosterApp initialisatie voltooid');
